export const SearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g clipPath="url(#clip0_1_3437)">
        <path d="M19.15 19.15L23 23M21.9 11.45C21.9 5.67862 17.2214 1 11.45 1C5.67862 1 1 5.67862 1 11.45C1 17.2214 5.67862 21.9 11.45 21.9C17.2214 21.9 21.9 17.2214 21.9 11.45Z" />
      </g>
      <defs>
        <clipPath id="clip0_1_3437">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
